import AutoplayController from "~/lib/autoplay_controller"
import { money, replay, tween } from "~/lib/motion"

// The cursor ticks add-ons above add to cart; the total grows, then it all goes in the cart
export default class extends AutoplayController {
  static targets = ["item", "total", "button", "count", "toast"]
  static values = { base: Number, picks: Array }

  reset() {
    this.itemTargets.forEach((item) => item.classList.remove("is-checked"))
    this.totalTarget.textContent = money(this.baseValue)
    this.buttonTarget.classList.remove("is-done")
    this.countTarget.textContent = "0"
    this.toastTarget.hidden = true
  }

  async play(wait) {
    let total = this.baseValue
    for (const index of this.picksValue) {
      const item = this.itemTargets[index]
      await wait(450)
      await this.click(item, wait)
      item.classList.add("is-checked")
      tween(this.totalTarget, total, total + Number(item.dataset.price))
      total += Number(item.dataset.price)
    }
    await wait(600)
    await this.click(this.buttonTarget, wait)
    this.buttonTarget.classList.add("is-done")
    this.countTarget.textContent = String(1 + this.picksValue.length)
    replay(this.countTarget, "is-bump")
    this.toastTarget.hidden = false
    replay(this.toastTarget, "is-pop")
  }
}
